//** Count Up **/
document.addEventListener("DOMContentLoaded", function() {
	var countUpElements = document.querySelectorAll('.count-up');

	var options = {
		threshold: 0.5
	};

	var observer = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				startCountUp(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, options);

	countUpElements.forEach(function(element) {
		observer.observe(element);
	});

	function startCountUp(element) {
		var from = parseInt(element.getAttribute('data-from'));
		var to = parseInt(element.getAttribute('data-to'));
		var speed = parseInt(element.getAttribute('data-speed')) || 100;

		var current = from;
		var interval = setInterval(function() {
			element.textContent = current;

			if (current < to) {
				current++;
			} else {
				clearInterval(interval);
			}
		}, speed);
	}
});